module.exports = __webpack_public_path__ + "static/media/How to update a document name.c8eed20e.png";